import { ArcElement, Chart as ChartJS, DoughnutController, Legend, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { DefaultTheme, useTheme } from 'styled-components';

import {
  ChartCenter,
  ChartNumber,
  ChartNumberWrapper,
  ChartPercentage,
  ChartTitle,
  ChartWrapper,
  CenterPercentage
} from './LiveClassesProgressChart.styles';

ChartJS.register(ArcElement, DoughnutController, Legend, Tooltip);

type Props = {
  seen: number;
  notSeen: number;
};

export const LiveClassesProgressChart: React.FC<Props> = ({ seen, notSeen }) => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const theme = useTheme() as DefaultTheme;

  const total = seen + notSeen;
  const percentage = total ? Math.round((seen / total) * 100) : 0;

  const data = {
    labels: [t('NOT_SEEN_CLASSES'), t('SEEN_CLASSES')],
    datasets: [
      {
        data: [notSeen, seen],
        backgroundColor: [theme.colors.black2, theme.colors.green6],
        borderWidth: 0,
        borderRadius: 20,
        spacing: -15
      }
    ]
  };

  const options = {
    responsive: false,
    maintainAspectRatio: false,
    elements: {
      arc: {
        borderJoinStyle: 'round'
      }
    },
    cutout: '85%',
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true
      }
    }
  } as const;

  return (
    <ChartCenter>
      <ChartWrapper>
        <Doughnut width={150} height={150} data={data} options={options} />
        <CenterPercentage>
          <ChartNumberWrapper>
            <ChartNumber>{percentage}</ChartNumber>
            <ChartPercentage>%</ChartPercentage>
          </ChartNumberWrapper>
          <ChartTitle>{t('SEEN_CLASSES')}</ChartTitle>
        </CenterPercentage>
      </ChartWrapper>
    </ChartCenter>
  );
};
